import { render, staticRenderFns } from "./DashboardCanceledReservation.vue?vue&type=template&id=38b110a0&scoped=true&"
import script from "./DashboardCanceledReservation.vue?vue&type=script&lang=js&"
export * from "./DashboardCanceledReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b110a0",
  null
  
)

export default component.exports